import Form from '../../blocks/Form/Form';
import FormAgeField from '../../blocks/FormAgeField/FormAgeField';
import FormCertifiedTeacherField from '../../blocks/FormCertifiedTeacherField/FormCertifiedTeacherField';
import FormCityField from '../../blocks/FormCityField/FormCityField';
import FormDiscoveryChannelField from '../../blocks/FormDiscoveryChannelField/FormDiscoveryChannelField';
import FormEmailField from '../../blocks/FormEmailField/FormEmailField';
import FormInfluencerCampaignField from '../../blocks/FormInfluencerCampaignField/FormInfluencerCampaignField';
import FormIntentField from '../../blocks/FormIntentField/FormIntentField';
import FormLastNameField from '../../blocks/FormLastNameField/FormLastNameField';
import FormLeadOwnerEmailField from '../../blocks/FormLeadOwnerEmailField/FormLeadOwnerEmailField';
import FormLegalText from '../../blocks/FormLegalText/FormLegalText';
import FormMessageField from '../../blocks/FormMessageField/FormMessageField';
import FormNameField from '../../blocks/FormNameField/FormNameField';
import FormNewsletterField from '../../blocks/FormNewsletterField/FormNewsletterField';
import FormOnlineOrRemoteField from '../../blocks/FormOnlineOrRemoteField/FormOnlineOrRemoteField';
import FormPhoneField from '../../blocks/FormPhoneField/FormPhoneField';
import FormPostalCodeField from '../../blocks/FormPostalCodeField/FormPostalCodeField';
import FormPromoCodeField from '../../blocks/FormPromoCodeField/FormPromoCodeField';
import FormSchoolGradeField from '../../blocks/FormSchoolGradeField/FormSchoolGradeField';
import FormSchoolLevelField from '../../blocks/FormSchoolLevelField/FormSchoolLevelField';
import FormSharePersonalDataTutorField from '../../blocks/FormSharePersonalDataTutorField/FormSharePersonalDataTutorField';
import FormStaticTextField from '../../blocks/FormStaticTextField/FormStaticTextField';
import FormSubjectField from '../../blocks/FormSubjectField/FormSubjectField';
import FormTermsAndConditionsField from '../../blocks/FormTermsAndConditionsField/FormTermsAndConditionsField';
import FormTermsAndConditionsTutorField from '../../blocks/FormTermsAndConditionsTutorField/FormTermsAndConditionsTutorField';
import FormTutoringSubjectsField from '../../blocks/FormTutoringSubjectsField/FormTutoringSubjectsField';
import FormUserTypeField from '../../blocks/FormUserTypeField/FormUserTypeField';

export const formComponents = {
  Form,
  FormAgeField,
  FormCertifiedTeacherField,
  FormCityField,
  FormDiscoveryChannelField,
  FormEmailField,
  FormInfluencerCampaignField,
  FormIntentField,
  FormLastNameField,
  FormLeadOwnerEmailField,
  FormLegalText,
  FormMessageField,
  FormNameField,
  FormNewsletterField,
  FormOnlineOrRemoteField,
  FormPhoneField,
  FormPostalCodeField,
  FormPromoCodeField,
  FormSchoolGradeField,
  FormSchoolLevelField,
  FormSharePersonalDataTutorField,
  FormStaticTextField,
  FormSubjectField,
  FormTermsAndConditionsField,
  FormTermsAndConditionsTutorField,
  FormTutoringSubjectsField,
  FormUserTypeField,
};
